document.documentElement.classList.remove("no-js");
document.addEventListener("DOMContentLoaded",function(){
  var header=document.querySelector("[data-mep-header]");
  if(header){
    var toggle=header.querySelector(".mep-menu-toggle");
    var nav=header.querySelector(".mep-nav");
    function closeMobileNav(){
      if(!nav||!toggle)return;
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded","false");
      document.body.classList.remove("mep-mobile-nav-open");
    }
    if(toggle&&nav){
      toggle.addEventListener("click",function(){
        var open=nav.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded",String(open));
        document.body.classList.toggle("mep-mobile-nav-open",open);
      });
      nav.addEventListener("click",function(event){
        if(event.target.closest("a"))closeMobileNav();
      });
    }
    var dropdowns=Array.from(header.querySelectorAll("[data-nav-dropdown]"));
    dropdowns.forEach(function(item){item.addEventListener("toggle",function(){if(item.open){dropdowns.forEach(function(other){if(other!==item)other.open=false;});}});});
    document.addEventListener("click",function(event){if(!header.contains(event.target)){dropdowns.forEach(function(item){item.open=false;});closeMobileNav();}});
    document.addEventListener("keydown",function(event){if(event.key==="Escape"){dropdowns.forEach(function(item){item.open=false;});closeMobileNav();}});
  }
  document.querySelectorAll("[data-mep-calculator]").forEach(function(calc){
    var fields={currency:calc.querySelector("[data-currency]"),value:calc.querySelector("[data-value]"),events:calc.querySelector("[data-events]"),hours:calc.querySelector("[data-hours]"),scrap:calc.querySelector("[data-scrap]"),result:calc.querySelector("[data-result]")};
    var touched=false;
    function update(){
      var total=(Number(fields.value.value)||0)*(Number(fields.events.value)||0)*(Number(fields.hours.value)||0)+(Number(fields.scrap.value)||0)*(Number(fields.events.value)||0);
      total=Math.max(0,total);
      var formatted=new Intl.NumberFormat("en-US",{style:"currency",currency:fields.currency.value,maximumFractionDigits:0}).format(total);
      fields.result.textContent=formatted;
      /* Persist the figure so the assessment form can attach it to the lead.
         Only written once the visitor has actually interacted, so an untouched
         calculator never sends its placeholder default. */
      if(touched&&total>0&&window.mepConsent&&window.mepConsent()==="accepted"){
        try{window.sessionStorage.setItem("mep-interruption-estimate",formatted+" ("+fields.currency.value+", estimated annual interruption cost)");}catch(error){}
      }
    }
    Object.keys(fields).forEach(function(key){if(key!=="result")fields[key].addEventListener("input",function(){touched=true;update();});});
    update();
  });

  /* Cookie notice.

     TWO PATHS, NOT ONE. This banner used to carry a single Accept button and
     no way to decline, while snippets/mep-crm-form-bridge forwarded name,
     email, phone, company, message, the full page URL and UTM parameters to a
     third-party gateway. A notice with no decline is not a choice.

     WHAT DECLINE ACTUALLY DOES, because a decline that changes nothing is
     worse than no decline at all. Two of the three things this site keeps in
     the browser are lead enrichment rather than essential:
       mep-interruption-estimate   the calculator figure, attached to the lead
       mep-lead-attribution        utm_source, utm_medium, utm_campaign
     Declining stops both from being written, clears anything already stored,
     and stops the CRM bridge forwarding them. The site keeps working. MEP just
     learns less about where the visitor came from. Only the choice itself is
     stored either way.

     window.mepConsent() returns "accepted", "declined" or "" and is read by
     the calculator above and by the CRM bridge. It has to live on window: the
     bridge is a separate inline script with no other way to ask.

     Built with createElement and textContent rather than innerHTML. The href
     is assembled from window.location.pathname, and although the regex below
     constrains that to a locale segment, a URL should not be concatenated into
     markup on the strength of one regex.

     The notice links MEP's own Privacy Notice at /pages/privacy-notice, not
     Shopify's boilerplate at /policies/privacy-policy. The footer links the
     same page, so a visitor reads one privacy document wherever they click.

     Locale prefix: Spanish pages are served under /es/, and a bare
     "/pages/..." href would drop the reader back into English. The prefix is
     read off the current path rather than hardcoded, so adding a third
     locale needs no change here. Copy follows the same switch. */
  var cookieKey="mep-cookie-consent";
  var legacyKey="mep-essential-cookie-consent";
  function readConsent(){
    try{
      var stored=window.localStorage.getItem(cookieKey);
      if(stored==="accepted"||stored==="declined")return stored;
      if(window.localStorage.getItem(legacyKey)==="accepted")return "accepted";
    }catch(error){}
    return "";
  }
  window.mepConsent=readConsent;
  if(!readConsent()){
    var mepLocale=(document.documentElement.getAttribute("lang")||"").toLowerCase().slice(0,2);
    var mepPrefix=/^\/([a-z]{2}(-[a-z]{2})?)\//i.test(window.location.pathname)?"/"+window.location.pathname.split("/")[1]:"";
    var mepIsEs=mepLocale==="es";
    var mepPrivacyHref=mepPrefix+"/pages/privacy-notice";
    var mepCopy=mepIsEs
      ?{label:"Privacidad",text:" Usamos cookies esenciales para que el sitio funcione. Si acepta, tambi\u00e9n registramos c\u00f3mo lleg\u00f3 al sitio y el resultado de la calculadora para adjuntarlos a su solicitud. ",link:"Aviso de Privacidad",accept:"Aceptar",decline:"Solo lo esencial",aria:"Aviso de cookies"}
      :{label:"Privacy",text:" We use essential cookies to keep this site working. If you accept, we also record how you reached the site and your calculator result, so they can be attached to your request. ",link:"Privacy Notice",accept:"Accept",decline:"Essential only",aria:"Cookie notice"};
    var banner=document.createElement("section");
    banner.className="mep-cookie-banner";
    banner.setAttribute("role","dialog");
    banner.setAttribute("aria-label",mepCopy.aria);
    var inner=document.createElement("div");
    inner.className="mep-cookie-inner";
    var copy=document.createElement("p");
    var strong=document.createElement("span");
    strong.textContent=mepCopy.label;
    copy.appendChild(strong);
    copy.appendChild(document.createTextNode(mepCopy.text));
    var link=document.createElement("a");
    link.className="mep-cookie-link";
    link.setAttribute("href",mepPrivacyHref);
    link.textContent=mepCopy.link;
    copy.appendChild(link);
    inner.appendChild(copy);
    var actions=document.createElement("div");
    actions.className="mep-cookie-actions";
    var decline=document.createElement("button");
    decline.className="mep-cookie-decline";
    decline.type="button";
    decline.textContent=mepCopy.decline;
    var accept=document.createElement("button");
    accept.className="mep-cookie-accept";
    accept.type="button";
    accept.textContent=mepCopy.accept;
    actions.appendChild(decline);
    actions.appendChild(accept);
    inner.appendChild(actions);
    banner.appendChild(inner);
    document.body.appendChild(banner);
    function mepChoose(value){
      try{window.localStorage.setItem(cookieKey,value);}catch(error){}
      if(value==="declined"){
        try{
          window.sessionStorage.removeItem("mep-interruption-estimate");
          window.sessionStorage.removeItem("mep-lead-attribution");
        }catch(error){}
      }
      banner.classList.add("is-dismissed");
      banner.addEventListener("transitionend",function(){banner.remove();},{once:true});
      window.setTimeout(function(){if(banner.isConnected)banner.remove();},260);
    }
    accept.addEventListener("click",function(){mepChoose("accepted");});
    decline.addEventListener("click",function(){mepChoose("declined");});
  }

});